import * as React from 'react';
import { useHistory, useLocation } from 'react-router';
import { useUiState } from 'state/ui-state/ui-state';

const LocationListenerWrapper: React.FunctionComponent<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const { addNewLastLocation } = useUiState();
  const history = useHistory();
  const location = useLocation();
  React.useEffect(() => {
    if (!history || !addNewLastLocation || !location.pathname) {
      return;
    }
    addNewLastLocation(location.pathname); // Initial location
    const unlisten = history.listen((history) => {
      addNewLastLocation(history.pathname);
    });
    return unlisten;
  }, [history, addNewLastLocation, location.pathname]);

  return <>{children}</>;
};

export default LocationListenerWrapper;
